// extracted by mini-css-extract-plugin
export default {"Header":"EYg19V3l_knBIU445D7S","ActionButton":"dnwWtKetnUZvvzxBd8E4","ActionButtonDisabled":"tKRXq7hYLmh8uCtPtWwj","RevokeButton":"tVLkIKqLS26kRjuI3nn2"};